import type { ApolloNativeModule } from "../../apollo";
import TypedNativeModules from "../internal/TypedNativeModules";

// This is all the cookie keys RN can access
export enum CookieKey {
  recentSearch = "RQ",
  lastVisit = "LV",
  dsaCompliant = "DSANR",
  recentSponsoredJobClick = "RSJC",
  recentOrganicJobClick = "ROJC",
  referral = "RF",
  applyStartCookie = "RJAS",
  previousPageNumber = "PP",
  publisherNumber = "pub",
  applyCountHistogram = "KZXEE",
  clickTrackingLog = "MCLK",
  desktopClickTrackingLog = "RCLK",
  stealthGroups = "sgroups",
  // MAGUA app download promo frequency control cookies
  maguaSuppressG1T = "_MAGUA_SprssG1T",
  maguaPageVisitsCount = "_MAGUA_PgVsts",
  maguaPromoShownInSessionCount = "_MAGUA_SsnShwnCnt",
  maguaPromoShownInMonthOrWeekCount = "_MAGUA_MnthShwnCnt",
  maguaPromoClosedInSessionCount = "_MAGUA_SsnClsdCnt",
  maguaPromoClosedInMonthCount = "_MAGUA_MnthClsdCnt",
  // Career Scout Hub W2A frequency cookies (MAGUA cadence; do not reuse MAGUA keys)
  csW2aPageVisitsCount = "_CS_W2A_PgVsts",
  csW2aPromoShownInSessionCount = "_CS_W2A_SsnShwnCnt",
  csW2aPromoShownInMonthOrWeekCount = "_CS_W2A_MnthShwnCnt",
}

export interface RNCoreNativeModule extends ApolloNativeModule {
  // Usable after DROID-7368
  onScroll?(scrollX: number, scrollY: number): void;
  close(rootTag: number): Promise<void>;
  onMainContentScrolled?(
    rnScrollModule: string,
    isScrollUp: boolean,
    isAtTop: boolean,
  ): Promise<void>;
  aceNewConversation(
    content?: string,
    agentType?: string,
    optionalArgs?: { [_: string]: string },
  ): Promise<void>;

  getCookies?<K extends CookieKey>(cookieNames: readonly K[]): Promise<Record<K, string | null>>;
  setCookies?<K extends CookieKey>(cookies: Array<{ name: K; value: string }>): Promise<void>;
  deleteCookies?<K extends CookieKey>(cookieNames: readonly K[]): Promise<void>;
  mutateTrackedOneGraphOperation?(
    mutationString: string,
    variablesJSONString: string,
    operationName: string | null,
    headers?: string,
    options?: string,
  ): Promise<any>;
  getDevParamsSync?(): string | null;
}

export function coreNativeModule() {
  return TypedNativeModules.RNCoreNativeModule;
}
